import * as ApiWithToken from "../callApiWithToken";
import {
  IActivationIn,
  IActivationUpdateIn,
} from "../../models/input/agendaApi/IActivationIn";
import { IJsonDate } from "../../models/dto/agendaApi/IActivationAssignmentDto";

const activationsService = {
  getActivationCategories: async function (languageId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/GetActivationCategories?LanguageID=${languageId}`
    );
  },
  getActivationFunds: async function (languageId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/GetActivationFunds?LanguageID=${languageId}`
    );
  },
  getActivationFamilies: async function (
    subcategoryList: string,
    languageId: number
  ) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/GetActivationFamilies?LanguageID=${languageId}`,
      subcategoryList
    );
  },
  getActivationTypes: async function (categoryId: number, languageId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/GetActivationTypes?CategoryID=${categoryId}&LanguageID=${languageId}`
    );
  },
  getActivationTechnologies: async function (
    categoryId: number,
    languageId: number
  ) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/GetActivationTechnologies?CategoryID=${categoryId}&LanguageID=${languageId}`
    );
  },
  postActivation: async function (activationIn: IActivationIn) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_AGENDAS_API + `Activations/CreateActivation`,
      activationIn
    );
  },
  getActivations: async function () {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API + `Activations/GetActivations`
    );
  },
  getActivationProducts: async function (model: string) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/GetActivationProducts?Model=${model}`
    );
  },
  deleteActivation: async function (activationId: number) {
    return ApiWithToken.deleteApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/DeleteActivation?ActivationID=${activationId}`
    );
  },
  postImageActivation: async function (imageFile: FormData) {
    return ApiWithToken.postImageApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/UploadActivationImage?Folder=Activations`,
      imageFile
    );
  },
  updateStateActivation: async function (
    activationId: number,
    activationState: boolean
  ) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/UpdateActivationStatus?ActivationID=${activationId}&State=${activationState}`,
      null
    );
  },
  updateActivation: async function (activationUpdateIn: IActivationUpdateIn) {
    return ApiWithToken.putApi(
      process.env.REACT_APP_AGENDAS_API + `Activations/UpdateActivation`,
      activationUpdateIn
    );
  },
  getActivationPrintProducts: async function (model: string) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/GetActivationPrintProducts?Model=${model}`
    );
  },
  getAssignmentOfActivation: async function (
    activationID: number,
    pageNumber: number
  ) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/GetAssignmentOfActivations?ActivationID=${activationID}&PageNumber=${pageNumber}`
    );
  },
  deleteAssignmentOfActivation: async function (
    activationAssignmentsID: number
  ) {
    return ApiWithToken.putApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/DeleteAssignmentOfActivations`,
      {
        userID: 0,
        activationAssignmentsID: activationAssignmentsID,
      }
    );
  },
  updateAssignmentOfActivation: async function (
    activationAssignmentsID: number,
    startDate: string | undefined,
    endDate: string | undefined
  ) {
    return ApiWithToken.putApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/UpdateAssignmentOfActivations`,
      {
        userID: 0,
        activationAssignmentsID: activationAssignmentsID,
        startDate: startDate,
        endDate: endDate,
      }
    );
  },
  createAssignmentOfActivation: async function (json: [{}]) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/CreateAssignmentOfActivations`,
      json
    );
  },
  updateAssignmentOfActivationInBulk: async function (
    activationAssignmentsIDs: string,
    startDate: string,
    endDate: string
  ) {
    return ApiWithToken.putApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/UpdateAssignmentOfActivationsInBulk`,
      {
        userID: 0,
        activationAssignmentsIDs: activationAssignmentsIDs,
        startDate: startDate,
        endDate: endDate,
      }
    );
  },
  deleteAssignmentOfActivationInBulk: async function (
    activationAssignmentsIDs: string
  ) {
    return ApiWithToken.putApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/DeleteAssignmentOfActivationsInBulk`,
      {
        userID: 0,
        activationAssignmentsIDs: activationAssignmentsIDs,
      }
    );
  },
  getClassificationOptions: async function (languageId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/GetClassificationOptions?LanguageID=${languageId}`
    );
  },
  getAssignmentOfActivationsExcel: async function (languageId: number) {
    return ApiWithToken.getApiBlob(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/getAssignmentOfActivationsExcel?languageID=${languageId}`
    );
  },
  createAssignmentOfActivationInBulk: async function (json: IJsonDate[]) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/CreateAssignmentOfActivationsInBulk`,
      json
    );
  },
};
export default activationsService;
